import React, { memo } from "react";
import { NextIcon, PrevIcon } from "./icons";

const PaginationBar = ({
  onPreviousPage,
  onNextPage,
  gotoPage,
  totalPage,
  pageIndex,
}) => {
  if (totalPage < 2) return null;

  const PaginationCell = ({ index }) => {
    return (
      <li
        key={`page-${index}`}
        className={`page-item ${index === pageIndex ? "active" : ""}`}
      >
        <a
          className="page-link"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            gotoPage(index);
          }}
        >
          {index + 1}
        </a>
      </li>
    );
  };
  const PaginationComponent = () => {
    if (totalPage < 6) {
      return (
        <>
          {Array.from({ length: totalPage }, (_, i) => (
            <PaginationCell key={i.toString()} index={i} />
          ))}
        </>
      );
    } else {
      if (pageIndex < 3) {
        return (
          <>
            {Array.from({ length: 3 }, (_, i) => (
              <PaginationCell key={i.toString()} index={i} />
            ))}
            <li className="page-item disabled">
              <a
                className="page-link"
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                ...
              </a>
            </li>
            <PaginationCell index={totalPage - 1} />
          </>
        );
      } else if (pageIndex > totalPage - 3) {
        return (
          <>
            <PaginationCell index={0} />
            <li className="page-item disabled">
              <a
                className="page-link"
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                ...
              </a>
            </li>
            {Array.from({ length: 3 }, (_, i) => (
              <PaginationCell key={i.toString()} index={totalPage - 3 + i} />
            ))}
          </>
        );
      } else {
        return (
          <>
            <PaginationCell index={0} />
            <li className="page-item disabled">
              <a
                className="page-link"
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                ...
              </a>
            </li>
            <PaginationCell index={pageIndex - 1} />
            <PaginationCell index={pageIndex} />
            <PaginationCell index={pageIndex + 1} />
            <li className="page-item disabled">
              <a
                className="page-link"
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                ...
              </a>
            </li>
            <PaginationCell index={totalPage - 1} />
          </>
        );
      }
    }
  };
  return (
    <div className="d-flex justify-content-between align-items-center border-top border-1 pt-3 flex-column flex-md-row px-4">
      <div className="d-flex align-items-center">
        Showing{" "}
        <input
          type="text"
          style={{ width: "3rem" }}
          className="text-dark form-control mx-2 px-2 py-1 text-center"
          value={pageIndex + 1}
          onChange={(event) => {
            const page = event.target.value
              ? Number(event.target.value) - 1
              : 0;
            gotoPage(page);
          }}
        />{" "}
        of <span className="text-dark ms-2"> {totalPage}</span>
      </div>
      <nav aria-label="Page navigation example" className="mt-3 mt-md-0">
        <ul className="pagination mb-0">
          <li className="page-item">
            <a
              className="page-link"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onPreviousPage();
              }}
            >
              <PrevIcon />
            </a>
          </li>

          <PaginationComponent />

          <li className="page-item ">
            <a
              className="page-link"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onNextPage();
              }}
            >
              <NextIcon />
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default memo(PaginationBar);
